import React, { useEffect, useState } from "react";
import { AgCharts } from "ag-charts-react";
import DropdownFilter from "../Components/DropdownFilter";

function DepositAndWithdrawal({ data }) {
  const [graphData, setGraphData] = useState([]);
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });
  }
  // const data = {
  //   deposit: {
  //     "x-axis": [
  //       "Oct-23",
  //       "Nov-23",
  //       "Dec-23",
  //       "Jan-24",
  //       "Feb-24",
  //       "Mar-24",
  //       "Apr-24",
  //       "May-24",
  //       "Jun-24",
  //       "Jul-24",
  //       "Aug-24",
  //       "Sep-24",
  //       "Oct-24",
  //     ],
  //     "y-axis": [
  //       64779.0, 255155.4, 54125.0, 53472.0, 41071.0, 53611.0, 66705.0, 61435.0,
  //       41459.0, 288359.0, 75296.25, 439232.0, 70.0,
  //     ],
  //   },
  //   withdrawal: {
  //     "x-axis": [
  //       "Oct-23",
  //       "Nov-23",
  //       "Dec-23",
  //       "Jan-24",
  //       "Feb-24",
  //       "Mar-24",
  //       "Apr-24",
  //       "May-24",
  //       "Jun-24",
  //       "Jul-24",
  //       "Aug-24",
  //       "Sep-24",
  //       "Oct-24",
  //     ],
  //     "y-axis": [
  //       64150.0, 228892.4, 63643.58, 60390.0, 56812.8, 51267.0, 55796.87,
  //       73436.82, 41051.0, 270262.0, 120860.0, 378491.0, 74744.66,
  //     ],
  //   },
  //   recurrent_deposit: {
  //     "x-axis": [
  //       "Oct-23",
  //       "Nov-23",
  //       "Dec-23",
  //       "Jan-24",
  //       "Feb-24",
  //       "Mar-24",
  //       "Apr-24",
  //       "May-24",
  //       "Jun-24",
  //       "Jul-24",
  //       "Aug-24",
  //       "Sep-24",
  //       "Oct-24",
  //     ],
  //     "y-axis": [
  //       54422.0, 42722.0, 42702.0, 53472.0, 40922.0, 42722.0, 56272.0, 41273.0,
  //       41273.0, 164539.0, 0.0, 263016.0, 0.0,
  //     ],
  //   },
  //   recurrent_withdrawal: {
  //     "x-axis": [
  //       "Oct-23",
  //       "Nov-23",
  //       "Dec-23",
  //       "Jan-24",
  //       "Feb-24",
  //       "Mar-24",
  //       "Apr-24",
  //       "May-24",
  //       "Jun-24",
  //       "Jul-24",
  //       "Aug-24",
  //       "Sep-24",
  //       "Oct-24",
  //     ],
  //     "y-axis": [
  //       0.0, 20000.0, 35000.0, 35000.0, 10000.0, 10000.0, 10000.0, 0.0, 5000.0,
  //       56585.0, 75455.0, 174255.0, 73000.0,
  //     ],
  //   },
  //   nonrecurrent_deposit: {
  //     "x-axis": [
  //       "Oct-23",
  //       "Nov-23",
  //       "Dec-23",
  //       "Jan-24",
  //       "Feb-24",
  //       "Mar-24",
  //       "Apr-24",
  //       "May-24",
  //       "Jun-24",
  //       "Jul-24",
  //       "Aug-24",
  //       "Sep-24",
  //       "Oct-24",
  //     ],
  //     "y-axis": [
  //       10357.0, 212433.4, 11423.0, 0.0, 149.0, 10889.0, 10433.0, 20162.0,
  //       186.0, 123820.0, 75296.25, 176216.0, 70.0,
  //     ],
  //   },
  //   nonrecurrent_withdrawal: {
  //     "x-axis": [
  //       "Oct-23",
  //       "Nov-23",
  //       "Dec-23",
  //       "Jan-24",
  //       "Feb-24",
  //       "Mar-24",
  //       "Apr-24",
  //       "May-24",
  //       "Jun-24",
  //       "Jul-24",
  //       "Aug-24",
  //       "Sep-24",
  //       "Oct-24",
  //     ],
  //     "y-axis": [
  //       64150.0, 208892.4, 28643.58, 25390.0, 46812.8, 41267.0, 45796.87,
  //       73436.82, 36051.0, 213677.0, 45405.0, 204236.0, 1744.66,
  //     ],
  //   },
  // };
  const [filter, setFilter] = useState({
    name: "Overall",
    value: "overall_summary",
  });

  const mapData = (data) => {
    if (data.deposit === null || data.deposit === undefined) return [];
    const res = data?.deposit["x-axis"]?.map((item, index) => {
      return {
        quarter: item,
        deposit: data?.deposit["y-axis"][index],
        withdrawal: data?.withdrawal["y-axis"][index],
        recurrent_deposit: data?.recurrent_deposit["y-axis"][index],
        recurrent_withdrawal: data.recurrent_withdrawal["y-axis"][index],
      };
    });
    return res;
  };
  const [options, setOptions] = useState({
    data: graphData,
    series: [
      {
        type: "bar",
        xKey: "quarter",
        yKey: "deposit",
        yName: "deposit",
        cornerRadius: 10,

        fill: " rgba(247, 164, 82, 0.8)",
      },
      {
        type: "bar",
        xKey: "quarter",
        yKey: "withdrawal",
        yName: "withdrawal",
        cornerRadius: 10,
        fill: "rgba(0, 112, 210, 0.8)",
      },
      {
        type: "line",
        xKey: "quarter",
        yKey: "recurrent_deposit",
        yName: "recurrent_deposit",
        stroke: "#FFa03a",
        strokeWidth: 2,
        lineDash: [6, 3],
        marker: { enabled: false },
      },
      {
        type: "line",
        xKey: "quarter",
        yKey: "recurrent_withdrawal",
        yName: "recurrent_withdrawal",
        stroke: "#0070d2",
        strokeWidth: 2,
        lineDash: [6, 3],
        marker: { enabled: false },
      },
    ],
    axes: [
      {
        type: "category",
        position: "bottom",
        gridLine: false,
        label: {
          fontSize: 9,
          fontWeight: "light",
        },
      },
      {
        type: "number",
        position: "left",
        gridLine: false,
        label: {
          formatter: (params) => {
            // Format with thousand separators and add a currency symbol
            return `${formatToIndianRupees(params.value)}`;
          },
          fontSize: 11,
          fontWeight: "light",
        },
      },
    ],
    legend: {
      item: {
        label: {
          fontSize: 11, // Change the legend font size

          fontWeight: "normal",
          color: "#637381", // Change the legend font color
        },
        marker: {
          size: 10, // Change the size of the color boxes
        },
      },
    },
    height: 300,
  });
  useEffect(() => {
    setGraphData(
      mapData(
        data !== undefined ? data[filter.value]?.deposit_and_withdrawal : []
      )
    );
  }, [filter, data]);

  useEffect(() => {
    setOptions({ ...options, data: graphData });
  }, [graphData]);

  return (
    <div className=" w-[49.5%] rounded-lg border border-[#e6ebed] h-[347px] py-4 overflow-x-auto overflow-y-hidden">
      <div className=" px-4 flex justify-between  items-center w-full">
        <p className=" text-base font-semibold">Deposit & Withdrawal</p>
        <DropdownFilter filterValue={filter} setFilterValue={setFilter} />
      </div>
      <div className="h-full mt-1 ">
        {" "}
        <AgCharts options={options} />{" "}
      </div>
    </div>
  );
}

export default DepositAndWithdrawal;
